import {Pipe, PipeTransform} from "@angular/core";
import {SuggestionComplex} from "../../search/suggestions/suggestion-complex";
import {AppUtils} from "../app-utils";

@Pipe({name: 'filterEmptySuggestions', pure: false})
export class FilterEmptySuggestionsPipe implements PipeTransform {

  transform(items: SuggestionComplex[], type: String): SuggestionComplex[] {
    return AppUtils.getSuggestionComplexes(items, type);
  }
}
